module.exports = __webpack_public_path__ + "static/media/people-chat-square-fill.ad7c3d70.svg";